export enum IPageStatus {
    statusA = 'statusA',
    statusB = 'statusB',
    statusC = 'statusC',
    statusD = 'statusD',
}
